module.exports = __webpack_public_path__ + "static/Recordings-e2c5cca728e112196beb2cc2ebeed938.png";